export default "__VITE_ASSET__DAECbyA3__"